import { Sprite, SpriteFrame } from 'cc';
import { EDITOR } from 'cc/env';

declare module 'cc' {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    interface Sprite {
        spriteFrameChangeCallbackList: ((value: SpriteFrame) => SpriteFrame)[];

        registerSpriteFrameChangeCallback(callback: (value: SpriteFrame) => SpriteFrame): void;
        unregisterSpriteFrameChangeCallback(callback: (value: SpriteFrame) => SpriteFrame): void;
    }
}

Sprite.prototype.registerSpriteFrameChangeCallback = function registerSpriteFrameChangeCallback(this: Sprite, callback: (value: SpriteFrame) => SpriteFrame) {
    this.spriteFrameChangeCallbackList = this.spriteFrameChangeCallbackList ?? [];
    this.spriteFrameChangeCallbackList.push(callback);
};

Sprite.prototype.unregisterSpriteFrameChangeCallback = function unregisterSpriteFrameChangeCallback(
    this: Sprite,
    callback: (value: SpriteFrame) => SpriteFrame,
) {
    if (!this.isValid || !this.spriteFrameChangeCallbackList) {
        return;
    }
    const index = this.spriteFrameChangeCallbackList.indexOf(callback);
    if (index !== -1) {
        this.spriteFrameChangeCallbackList.splice(index, 1);
    }
};

const spriteFrameDescriptor = Object.getOwnPropertyDescriptor(Sprite.prototype, 'spriteFrame');
const spriteFrameSetter = spriteFrameDescriptor.set;
spriteFrameDescriptor.set = function set(this: Sprite, value: SpriteFrame) {
    const self: Sprite = this;
    let finalSpriteFrame: SpriteFrame = value;
    self.spriteFrameChangeCallbackList?.forEach((callback) => {
        finalSpriteFrame = callback(finalSpriteFrame);
    });
    spriteFrameSetter.call(self, finalSpriteFrame);
    if (!EDITOR) {
        this.emit(Sprite.EventType.SPRITE_FRAME_CHANGED, this);
    }
};
Object.defineProperty(Sprite.prototype, 'spriteFrame', spriteFrameDescriptor);
